import { styled, useTheme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const Background = styled('div')({
  // backgroundImage: 'url(/img/webp/thanks-background.webp)',
  // backgroundRepeat: 'no-repeat',
  // backgroundSize: 'cover',
  // backgroundPosition: 'center',

  height: '100vh',

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const FormContent = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: '486px',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(3),
  backgroundColor: theme.palette.mode === 'light' ? 'white' : theme.palette.background.default,
  borderRadius: theme.spacing(0.5),
}));

export const FormTitle = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

export const FormContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const StyledAnchor = styled('div')(({ theme }) => ({
  color: theme.palette.text.primary,
  textAlign: 'center',
}));

export const StyledText: SxProps = () => {
  const theme = useTheme();

  return {
    marginTop: theme.spacing(2.5),
  };
};
